import * as yup from 'yup'

const isFilled = (value) => String(value || '').trim() !== ''

const schema = () =>
  yup.object().shape({
    answers: yup.array().of(
      yup.object().shape({
        answer: yup.string().required(),
        how: yup.string().required(),
        why: yup.string().required(),
      }),
    ),
    extraDamageAnswers: yup
      .mixed()
      .test(
        'extra-damage-pairs',
        'Preencha "Como?" e "Por Que?" ou deixe ambos vazios.',
        function (value) {
          if (!value) return true
          const msg = 'Preencha "Como?" e "Por Que?" ou deixe ambos vazios.'
          const errors = []

          Object.entries(value).forEach(([key, entry]) => {
            if (!entry || typeof entry !== 'object') return
            const howFilled = isFilled(entry.how)
            const whyFilled = isFilled(entry.why)
            if (howFilled && !whyFilled) {
              errors.push(
                this.createError({
                  path: `extraDamageAnswers[${key}].why`,
                  message: msg,
                }),
              )
            } else if (!howFilled && whyFilled) {
              errors.push(
                this.createError({
                  path: `extraDamageAnswers[${key}].how`,
                  message: msg,
                }),
              )
            }
          })

          if (errors.length > 0) {
            return new yup.ValidationError(errors)
          }
          return true
        },
      ),
  })

export default schema
